import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(with-global-style)/mbbs/DesktopPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(with-global-style)/mbbs/MobilePage.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
